'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBusy = undefined;

var _AgentStates = require('../../constants/AgentStates');

var _isAgentState = require('./isAgentState');

var isBusy = exports.isBusy = (0, _isAgentState.isAgentState)(_AgentStates.BUSY);